import React from 'react';
import ReactDOM from 'react-dom';
import { StripePublishableKey } from './Data/config';

import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import SimpleDonationForm from './Components/SimpleDonationForm';

const stripePromise = loadStripe(StripePublishableKey);

const SimpleDonation = () => {
  return (
    <Elements stripe={stripePromise}>
      <SimpleDonationForm />
    </Elements>
  );
};

ReactDOM.render(<SimpleDonation />, document.getElementById('simple-donation'));
